var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ia-cliente-tarefas" },
    [
      _c(
        _vm.navegavel ? "button" : "div",
        {
          tag: "component",
          staticClass: "ia-cliente-tarefas__rotulo ia-texto-selo",
          attrs: { type: _vm.navegavel ? "button" : null },
          on: { click: _vm.aoClicar }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.rotulo))]),
          _vm.navegavel
            ? _c("icon-svg", {
                attrs: {
                  name: "arrow-left",
                  size: _vm.TAMANHO_CHEVRON,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          !_vm.carregando
            ? _c(
                "span",
                {
                  staticClass: "ia-sidebar-contador ml-auto",
                  attrs: { "data-test": "ia-cliente-tarefas-contador" }
                },
                [_vm._v(" " + _vm._s(_vm.contador) + " ")]
              )
            : _vm._e()
        ],
        1
      ),
      _vm.carregando
        ? _c(
            "ul",
            { staticClass: "ia-cliente-tarefas__lista" },
            _vm._l(_vm.LINHAS_PENDENTES, function(linha) {
              return _c("li", { key: linha.chave }, [
                _c("span", { staticClass: "ia-cliente-tarefas__anel" }),
                _c(
                  "span",
                  { staticClass: "ia-cliente-tarefas__texto" },
                  [
                    _c(
                      "BaseLoadingSkeleton",
                      _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_TITULO, false)
                    ),
                    _c(
                      "BaseLoadingSkeleton",
                      _vm._b({}, "BaseLoadingSkeleton", _vm.CAIXA_PRAZO, false)
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        : _vm.vazio
        ? _c(
            "p",
            { staticClass: "ia-cliente-tarefas__vazio ia-texto-auxiliar" },
            [_vm._v(" Nenhuma tarefa pendente ")]
          )
        : _c(
            "ul",
            { staticClass: "ia-cliente-tarefas__lista" },
            _vm._l(_vm.tarefas, function(tarefa) {
              return _c("li", { key: tarefa.chave }, [
                _c("span", {
                  staticClass: "ia-cliente-tarefas__anel",
                  style: { borderColor: tarefa.corDoAnel }
                }),
                _c("span", { staticClass: "ia-cliente-tarefas__texto" }, [
                  _c(
                    "span",
                    {
                      staticClass: "ia-cliente-tarefas__titulo ia-texto-corpo"
                    },
                    [_vm._v(_vm._s(tarefa.titulo))]
                  ),
                  tarefa.prazo
                    ? _c(
                        "span",
                        {
                          staticClass:
                            "ia-cliente-tarefas__prazo ia-texto-auxiliar",
                          style: tarefa.alerta
                            ? { color: tarefa.corDoAnel }
                            : null
                        },
                        [_vm._v(" " + _vm._s(tarefa.prazo) + " ")]
                      )
                    : _vm._e()
                ])
              ])
            }),
            0
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }